import _ from 'lodash';
import { CutomizationPaletteMode } from './customization';
import bgLight from '../static/images/bglight.png';
import bgDark from '../static/images/bgdark.jpg';
import { globalConfig } from './tokens/global-config';
import { loginConfig } from './tokens/login-config';
import { semanticTokens } from './tokens/semantic-tokens'


export enum COLOR_KEY {
    standardBGColor = 'standardBGColor',
    textColor = 'textColor',
    topbarAfter = 'topbarAfter',
    navBackground = 'navBackground',
    navItemText = 'navItemText',
    boxShadow = 'boxShadow',
    countryListHighlight = 'countryListHighlight',
    scrollbarThumb = 'scrollbarThumb',
    reactDatepicker = 'reactDatepicker',
    borderColor = 'borderColor',
    disabledBtn = 'disabledBtn',
    appBackgroundImage = 'appBackgroundImage',

    // 语义色（与 semantic-tokens.ts 保持一致）
    // --- 字体 (Font) ---
    textLight = 'textLight',
    textDark = 'textDark',
    textSecondary = 'textSecondary',
    textPrimary100 = 'textPrimary100',
    textPrimary200 = 'textPrimary200',
    textPrimary300 = 'textPrimary300',
    textNeutral500 = 'textNeutral500',
    textNeutral600 = 'textNeutral600',

    // --- 图标/按钮 (Icon/Button) ---
    iconPrimary100 = 'iconPrimary100',
    iconPrimary200 = 'iconPrimary200',
    iconPrimary300 = 'iconPrimary300',
    iconNeutral100 = 'iconNeutral100',
    iconNeutral200 = 'iconNeutral200',
    iconNeutral300 = 'iconNeutral300',
    iconNeutral500 = 'iconNeutral500',
    iconNeutral600 = 'iconNeutral600',
    iconNeutral700 = 'iconNeutral700',
    iconNeutral800 = 'iconNeutral800',
    iconNeutral800A50 = 'iconNeutral800A50',

    // --- 填充 (Fill) ---
    fillNeutral100 = 'fillNeutral100',
    fillNeutral200 = 'fillNeutral200',
    fillPrimary200 = 'fillPrimary200',
    fillPrimary300 = 'fillPrimary300',
    fillNeutral600 = 'fillNeutral600',
    fillNeutral700 = 'fillNeutral700',
    fillNeutral800 = 'fillNeutral800',

    // --- 描边 (Stroke) ---
    strokePrimary100 = 'strokePrimary100',
    strokePrimary200 = 'strokePrimary200',
    strokePrimary300 = 'strokePrimary300',
    strokeNeutral100 = 'strokeNeutral100',
    strokeNeutral800 = 'strokeNeutral800',
    strokeNeutral800A25 = 'strokeNeutral800A25',

    // --- 遮罩 (Overlay) ---
    overlay100A50 = 'overlay100A50',
    overlay800A25 = 'overlay800A25',
    overlay800A50 = 'overlay800A50',

    // --- 投影 (Shadow) ---
    shadow25 = 'shadow25',
    shadow50 = 'shadow50',

    // --- 功能颜色 (Functional Colors) ---
    funcError = 'funcError',
    funcSuccess = 'funcSuccess',
    funcInfo = 'funcInfo',
    funcSp1 = 'funcSp1',
    funcSp2 = 'funcSp2',
    funcSp3 = 'funcSp3',
    funcSp4 = 'funcSp4',
    funcSp5 = 'funcSp5',
}

class Customization {

    constructor() {
        this.getModeColor = this.getModeColor.bind(this);

        // 合并各模块配置（全局、登录页等），按 COLOR_KEY 名称写入内部 values
        const allConfig: { [key: string]: (string | object)[] } = {
            // 全局通用配置
            ...globalConfig,
            // 语义色
            ...semanticTokens,
            // 登录页配置
            ...loginConfig,
            // 其他页面/模块可在此继续扩展
            appBackgroundImage: [
                `url(${bgLight})`,
                `url(${bgDark})`,
            ],
        };

        _.mapKeys(allConfig, (value, key) => {
            this.join(key, value)
        })
    }

    /**
     * 客制化配置表
     * - value 的值根据CutomizationPaletteMode的index赋值
     * @example
     * cutomizationPaletteMode = ['light', 'dark']
     * ['#fff','#000'] => { light: '#fff', dark: '#000'}
     */
    /**
     * 主题模式名词
     */
    public cutomizationPaletteMode: CutomizationPaletteMode[] = ['light', 'dark'];

    /**
     * 客制化配置表的值
     */
    public values: ThemeColorValues = {}

    /**
     * 导入值
     * @param key
     * @param colors
     */
    public join(key: string, colors: (string | object)[]) {

        const obj: ThemeColorConfig = {};

        this.cutomizationPaletteMode.forEach((mode, index) => {
            obj[mode] = colors[index];
        })
        const newValue = { [key]: obj };

        this.values = Object.assign({}, this.values, newValue)
    }

    /**
     * 获取相应的模式的值
     * @param key
     * @param mode
     * @returns
     */
    public getModeColor(key: COLOR_KEY, mode: CutomizationPaletteMode) {
        if (mode) {
            return this.values[key][mode];
        }
    }

    // public get value(): ThemeColorValues {
    //     return this.values
    // }

}

const CustomizationValue = new Customization();

type ThemeColorConfig = { [k in CutomizationPaletteMode]?: (string | object) };

type ThemeColorValues = { [k: string]: ThemeColorConfig };


export const getModeColor = CustomizationValue.getModeColor;
